// The number is allocated when the submission is created, after confirmation.
export const SUBMISSION_NUMBER_PLACEHOLDER = 'Sub # (added automatically)';

export function normalizeSubmissionEmailBody(value: string, submissionNumber?: number | string): string {
  const marker = submissionNumber === undefined
    ? SUBMISSION_NUMBER_PLACEHOLDER
    : `Sub #${submissionNumber}`;
  // Remove standalone identifiers before adding the authoritative one first.
  // A pasted number from another deal must not misroute a funder reply.
  const notes = value.replace(/\r\n?/g, '\n').split('\n')
    .filter(line => !/^Sub #\s*(?:\d+|\(added automatically\))$/i.test(line.trim()))
    .join('\n').trim();
  return notes ? `${marker}\n\n${notes}` : marker;
}

export function renderSubmissionEmailBodyHtml(value: string, submissionNumber: number | string): string {
  return normalizeSubmissionEmailBody(value, submissionNumber)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\n/g, '<br>');
}
